import React from 'react'
import { Image  } from 'semantic-ui-react'

export default function NoDataImage(props){
    let size = props.size !== undefined ? props.size : 'medium'
    return <Image className='centered' src={require('../../img/nodata.png')} size={size} />
}
